import { Alert, Button, Modal } from "@arco-design/web-react";
import { Copy } from "lucide-react";
import { useState } from "react";

import type { ItineraryCopyTarget } from "../types";
import { ItineraryCopyTargetSelect } from "./ItineraryCopyTargetSelect";

type Props = {
  hasSearched: boolean;
  items: ItineraryCopyTarget[];
  selectedDemandId: string;
  loading: boolean;
  copying: boolean;
  errorMessage: string;
  onSearch: (value: string) => void;
  onSelect: (demandId: string) => void;
  onConfirm: (replaceExisting?: boolean) => void | Promise<void>;
  onRetry: () => void;
};

/** 在预览操作栏上方选择关联定制并复制当前服务器版本。 */
export function ItineraryCopyBar({
  hasSearched,
  items,
  selectedDemandId,
  loading,
  copying,
  errorMessage,
  onSearch,
  onSelect,
  onConfirm,
  onRetry,
}: Props) {
  const [confirmVisible, setConfirmVisible] = useState(false);
  const selectedTarget = items.find((item) => item.demandId === selectedDemandId);
  const submitCopy = (replaceExisting = false) => {
    setConfirmVisible(false);
    void Promise.resolve().then(() => onConfirm(replaceExisting)).catch(() => undefined);
  };
  return (
    <>
      <div className="itinerary-copy-bar" aria-label="复制行程">
        <ItineraryCopyTargetSelect
          hasSearched={hasSearched}
          items={items}
          selectedDemandId={selectedDemandId}
          loading={loading}
          onSearch={onSearch}
          onSelect={onSelect}
        />
        <Button
          className="itinerary-copy-button"
          type="primary"
          icon={<Copy size={15} />}
          loading={copying}
          disabled={!selectedDemandId || copying}
          onClick={() => {
            if (selectedTarget?.hasItinerary) {
              setConfirmVisible(true);
              return;
            }
            submitCopy(false);
          }}
        >
          复制行程
        </Button>
        {errorMessage ? (
          <Alert
            type="error"
            showIcon
            content={errorMessage}
            action={<button type="button" className="itinerary-copy-retry" onClick={onRetry}>重试</button>}
          />
        ) : null}
      </div>
      <Modal
        visible={confirmVisible}
        title="确认替换定制版本关联行程"
        okText="确认复制"
        cancelText="取消"
        confirmLoading={copying}
        maskStyle={{ zIndex: 1299 }}
        wrapStyle={{ zIndex: 1300 }}
        onCancel={() => setConfirmVisible(false)}
        onOk={() => submitCopy(true)}
      >
        <p>
          {selectedTarget?.projectCode} {selectedTarget?.versionNumber} 已关联行程。
          确认后会创建新的行程并将该定制版本的当前关联切换到新行程，之前关联的行程保留但不再作为当前行程。
        </p>
      </Modal>
    </>
  );
}
